// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/chevron-compact-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* entry count */
#entry-count {
  color: #555;
}

/* search field box */
.search-field {
    display: flex;
    align-items: center;
    gap: 10px
}

.search-download-column select {
    font-size: 17px;
    box-sizing: content-box;
    height: 30px;
    padding: 10px 25px 10px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    letter-spacing: 0.5px; 
    appearance: none; 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 12px;
}

/* data table */
.data-table-container {
    margin: 20px auto;
    max-width: 90vw;
    max-height: 1000px;
    overflow: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.data-table-container th {
  cursor: pointer;
}

/* pagination */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90vw;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
}

.pagination-container > div {
  display: inline-block;
}

.page-size-selector select {
  padding: 5px 20px 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  letter-spacing: 0.5px; 
  appearance: none; 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  width: auto;
  list-style: none;
}

.pagination li {
  margin: 0 5px;
}

.pagination a {
  padding: 5px 10px;
  color: black;
  cursor: pointer;
}

.pagination a:hover {
  background-color: #3a89c9;
  color: white;
}

.pagination .active a {
  background-color: #3a89c9;
  color: white;
  cursor: default;
}

.pagination .disabled a {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
}

/* modal */
#modal-button {
  color: white;
  background-color: #3a89c9;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Legend */
.legend {
  display: flex;
  justify-content: flex-end;
  max-width: 95%;
  align-items: center;
  color: #141e27;
  font-size: 15px;
}

.color-box {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-right: 5px;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Data_cas9.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IAIrB,gBAAgB;IAChB,yDAA2D;IAC3D,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EAIrB,gBAAgB;EAChB,yDAA2D;EAC3D,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":["/* entry count */\n#entry-count {\n  color: #555;\n}\n\n/* search field box */\n.search-field {\n    display: flex;\n    align-items: center;\n    gap: 10px\n}\n\n.search-download-column select {\n    font-size: 17px;\n    box-sizing: content-box;\n    height: 30px;\n    padding: 10px 25px 10px 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    letter-spacing: 0.5px;\n\n    -webkit-appearance: none; \n    -moz-appearance: none; \n    appearance: none; \n    background-image: url('../assets/chevron-compact-down.svg');\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 12px;\n}\n\n/* data table */\n.data-table-container {\n    margin: 20px auto;\n    max-width: 90vw;\n    max-height: 1000px;\n    overflow: auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.data-table-container th {\n  cursor: pointer;\n}\n\n/* pagination */\n.pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 90vw;\n  margin-bottom: 30px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.pagination-container > div {\n  display: inline-block;\n}\n\n.page-size-selector select {\n  padding: 5px 20px 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n\n  -webkit-appearance: none; \n  -moz-appearance: none; \n  appearance: none; \n  background-image: url('../assets/chevron-compact-down.svg');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  width: auto;\n  list-style: none;\n}\n\n.pagination li {\n  margin: 0 5px;\n}\n\n.pagination a {\n  padding: 5px 10px;\n  color: black;\n  cursor: pointer;\n}\n\n.pagination a:hover {\n  background-color: #3a89c9;\n  color: white;\n}\n\n.pagination .active a {\n  background-color: #3a89c9;\n  color: white;\n  cursor: default;\n}\n\n.pagination .disabled a {\n  pointer-events: none;\n  color: gray;\n  cursor: not-allowed;\n}\n\n/* modal */\n#modal-button {\n  color: white;\n  background-color: #3a89c9;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Legend */\n.legend {\n  display: flex;\n  justify-content: flex-end;\n  max-width: 95%;\n  align-items: center;\n  color: #141e27;\n  font-size: 15px;\n}\n\n.color-box {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
